import usePrescriptionsPatients from '@hooks/query/e-prescriptions/usePrescriptionsPatients';
import { Drawer, PageHeaderWrapper, Table, Typography } from '@ui';
import React from 'react';
import { useIntl } from 'react-intl';
import { useTheme } from 'styled-components';
import { IPrescriptionTableItem } from 'types/e-prescription.types';
import PrescriptionsPatientsList from './components/prescriptions-patient-list';
import { useColumns } from './prescriptions.utils';

const Prescriptions: React.FC = () => {
  const { formatMessage } = useIntl();
  const theme = useTheme();
  const { data, isFetching } = usePrescriptionsPatients();

  const { close, open, data: drawerData, drawerProps } = Drawer.useDrawer<IPrescriptionTableItem>();
  const columns = useColumns({ onDetailClick: open });

  return (
    <>
      <PageHeaderWrapper>
        <Table.Header
          title={
            <>
              <Typography display="h5" as="span">
                {`${formatMessage({ id: 'prescriptions.table.title' })} (${data?.length ?? 0})`}
              </Typography>
              <Typography style={{ color: theme.color.tint.secondary }} display="body2">
                {formatMessage({ id: 'prescriptions.table.description' })}
              </Typography>
            </>
          }
        />
        <Table
          columns={columns}
          data={data ?? []}
          emptyTitle={formatMessage({ id: 'prescriptions.table.emptyTitle' })}
          showEmpty
          loading={isFetching}
        />
      </PageHeaderWrapper>
      <PrescriptionsPatientsList {...drawerProps} item={drawerData} onClose={close} />
    </>
  );
};

export default Prescriptions;
